import type { ItemFieldEntry } from '@cheqroom/api';

import type { InfoField } from '../../Info/fields/Fields.types';
import { resolveSystemFields, type SystemFieldReader } from '../../Info/fields/utils';
import type { KitInfoKit } from '../KitInfo.context';

/** `description` falls back to the kit's `itemSummary` when it is empty. */
const kitFieldReader: SystemFieldReader<KitInfoKit> = {
	readField: (kit, id) => {
		const record = kit as unknown as Record<string, unknown>;
		return id === 'description' ? record.description || record.itemSummary : record[id];
	},
	hasField: (kit, id) => id in kit || (id === 'description' && 'itemSummary' in kit),
};

export const resolveSystemFieldsFromKit = (kit: KitInfoKit, customFields: ItemFieldEntry[] = []): InfoField[] =>
	resolveSystemFields(kit, customFields, kitFieldReader);
